import {RadioGroupProps} from "./types";
import {RadioGroupEntry} from "./radio-group-entry";

export const RadioGroup = ({
  id,
  options,
  selected,
  onChange,
  message,
  onMessageChange,
}: RadioGroupProps) => (
  <fieldset id={id} className="w-full flex flex-col gap-4">
    {options.map(({value, label, description}) => (
      <RadioGroupEntry
        id={id}
        label={label}
        description={description}
        value={value}
        checked={selected === value}
        onChange={onChange}
        message={message}
        onMessageChange={onMessageChange}
      />
    ))}
  </fieldset>
)